import React, { Fragment } from 'react';
import { SearchInput } from 'seduo-ui';
const Example = () => (<Fragment>
        <SearchInput value="Test" onChange={() => undefined} onToggle={() => undefined} onKeyDown={() => undefined}/>

        <div className="pt-5">
            <SearchInput placeholder="Test placeholder" onChange={() => undefined} onToggle={() => undefined} onKeyDown={() => undefined}/>
        </div>
    </Fragment>);
export default Example;
